import { colors } from '../../../../../packages';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  event: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${colors.neutral100}`,
    borderRadius: 8,
    padding: 24,
    backgroundColor: colors.white,
  },
  infoLabel: {
    margin: 0,
    fontSize: 12,
    lineHeight: '20px',
    marginBottom: 4,
    display: 'block',
    textTransform: 'uppercase',
    color: colors.neutral500,
  },
  nofilter: {
    margin: 0,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral700,
  },
  infoValue: {
    margin: 0,
    fontSize: 14,
    lineHeight: '20px',
  },
  deleteBtn: {
    fontSize: 14,
    color: colors.destructive500,
  },
  editBtn: {
    fontSize: 14,
  },
});
